import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Icon from "@shared/components/Icon";
import React from "react";
import theme from "@project/theme/theme";
import SectionContainer from "./SectionContainer";
import DynamicContainer from "@project/templates/home/DynamicContainer";
const CtaBannerPart = ({ title, description, children, }) => {
    return (_jsx(SectionContainer, { backgroundColor: theme.palette.primary.main, hasDarkBackground: true, children: _jsxs(Stack, { spacing: { xs: 3, md: "28px" }, sx: { alignItems: "center" }, children: [_jsx(Icon, { type: "custom", icon: "relation_collaborateur", color: theme.palette.primary.contrastText, style: { minWidth: "54px", minHeight: "54px" } }), _jsxs(Stack, { spacing: { xs: 2, md: "28px" }, sx: { alignItems: "center" }, children: [_jsx(Typography, { component: "h2", variant: "h2", sx: {
                                color: "primary.contrastText",
                                fontWeight: 700,
                                lineHeight: { xs: "130%", md: "120%" },
                                letterSpacing: "0.02em",
                                textAlign: "center",
                                maxWidth: "680px",
                                fontSize: "24px",
                                "@media (min-width:1200px)": {
                                    fontSize: "36px",
                                },
                                "@media (min-width:1440px)": {
                                    fontSize: "40px",
                                },
                            }, children: title }), _jsx(Typography, { variant: "body1", sx: {
                                color: "primary.contrastText",
                                fontWeight: 400,
                                fontSize: { xs: "14px", md: "16px" },
                                lineHeight: { xs: "150%", md: "160%" },
                                textAlign: "center",
                                maxWidth: "590px",
                            }, children: description })] }), _jsx(DynamicContainer, { children: children })] }) }));
};
export default CtaBannerPart;
